import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import {
  AnswerDisplay,
  GroupType,
  PredictorGroupGames,
  ProcessedPredictorQuestion,
  ProcessedValuePredictorAnswer,
  ProcessedValuePredictorQuestion,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-game-predictor-result',
  templateUrl: './game-predictor-result.component.html',
  styleUrl: './game-predictor-result.component.scss',
})
export class GamePredictorResultComponent implements OnInit {
  @Input() predictorResult: PredictorGroupGames;
  @Input() sharedRedirectURL: string;
  @Input() pointIcon: string = 'loyalty';
  @Input() isExternal: boolean = false;
  @ContentChild('submissionFormContent', { static: false }) submissionFormTemplate: TemplateRef<any>;
  predictorValueQuestions: ProcessedValuePredictorQuestion[];
  groupType = GroupType.Predictor;
  answerDisplayEnum = AnswerDisplay;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.predictorValueQuestions = this.predictorResult.Questions.map((question) => {
      question.Answers = question.Answers.map((answer) => answer as ProcessedValuePredictorAnswer);
      return question as ProcessedValuePredictorQuestion;
    });
  }

  gettotalCorrectAnswer(): number {
    return this.predictorResult.Questions.map((question) => question as ProcessedPredictorQuestion).filter(
      (item) => item.IsCorrect
    ).length;
  }

  getTotalPointsForQuestion(questionId: number): number {
    return this.predictorResult.Questions.map((question) => question as ProcessedPredictorQuestion)
      .filter((question) => question.Id == questionId)
      .reduce((sum, current) => sum + current.PointsAwarded, 0);
  }

  // Handle manual modal close with custom buttons inside your Angular component
  closeModel(): void {
    this.modalService.dismissAll();
  }
}
